import React from 'react'

type Props = {
  onSubmit: any
  className?: string
}

export const AncientTabBodyForm: React.FC<Props> = ({onSubmit, children}) => {
  return (
    <form id='kt_modal_add_user_form' className='form' onSubmit={onSubmit} noValidate>
      <div className='py-5 px-3'>
        <div className='row rounded border py-5 px-3'>{children}</div>
      </div>
    </form>
  )
}
